export default "__VITE_ASSET__BJZYaE7u__"